import React, { useMemo } from 'react';
import { withTranslation } from 'react-i18next';
import { Typography, Box } from '@mui/material';

import { useMytaverseEvent } from '@core/dashboard/providers';
import ScrollableContainer from '@components/ScrollableContainer';
import RaisedHandParticipantItem from './RaisedHandParticipantItem';
import { useStyles } from './styles';
import { IRaisedHandsContent } from './interfaces';

const RaisedHandsContent = ({ t: translate }: IRaisedHandsContent) => {
  const classes = useStyles();

  const { participants } = useMytaverseEvent();

  // Filter and sort participants with raised hands
  const raisedHandParticipants = useMemo(() => {
    const filtered = participants.filter((p) => p.handRaised);
    // Sort by handRaisedAt timestamp (earliest first)
    return filtered.sort((a, b) => {
      const aTime = a.handRaisedAt || 0;
      const bTime = b.handRaisedAt || 0;
      return aTime - bTime;
    });
  }, [participants]);

  return (
    <ScrollableContainer sxProps={{ root: classes.scrollable }}>
      {!raisedHandParticipants.length ? (
        <Typography sx={classes.empty}>
          {translate('raisedHandsModal.empty')}
        </Typography>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            marginTop: 1,
          }}
        >
          {raisedHandParticipants.map((participant) => (
            <RaisedHandParticipantItem
              key={participant.participantId}
              participant={participant}
            />
          ))}
        </Box>
      )}
    </ScrollableContainer>
  );
};

export default withTranslation()(RaisedHandsContent);
